import { SITE_ALIASES_GRID_NAME } from '../../constants';

import { actionLoadSiteAliasesRequest } from '../../actions/siteAliasesGrid';

import {
  ACTION_DELETE_SITE_ALIAS__REQUEST,
  ACTION_DELETE_SITE_ALIAS__SUCCESS,
  ACTION_DELETE_SITE_ALIAS__FAIL,

  ACTION_CREATE_SITE_ALIAS__REQUEST,
  ACTION_CREATE_SITE_ALIAS__SUCCESS,
  ACTION_CREATE_SITE_ALIAS__FAIL,
} from '../../actionTypes';

import { getGridSaga } from 'react-redux-app/lib/modules/grid/sagas';


export default getGridSaga(
  SITE_ALIASES_GRID_NAME,
  actionLoadSiteAliasesRequest,
  [ACTION_DELETE_SITE_ALIAS__REQUEST, ACTION_CREATE_SITE_ALIAS__REQUEST],
  [ACTION_DELETE_SITE_ALIAS__FAIL, ACTION_CREATE_SITE_ALIAS__FAIL],
  [ACTION_DELETE_SITE_ALIAS__SUCCESS, ACTION_CREATE_SITE_ALIAS__SUCCESS]
);
